// src/components/ui/AdvancedToggle.jsx
//
// The "Avanzate" switch (v198). Presentational: the caller owns the value (useAdvancedView + any forced
// reveal). While OFF it says how many hidden fields need attention (`hiddenCount` > 0 → a badge), so a hidden
// error or AI warning is never hidden in silence. role="switch" + aria-checked; the badge text is part of the
// accessible name. Labels come from the caller (no copy here).
import React from 'react';
import { COLORS, FONT_SANS, RADII, SEMANTIC } from '../../constants/theme.js';

// A bordered control, not bare text: it hides or reveals whole sections of a form, so it must be noticed.
// The border and fill turn accent-tinted while ON, so the state also reads at a glance.
const wrap = (on) => ({
  display: 'inline-flex', alignItems: 'center', gap: '10px', padding: '8px 14px',
  borderRadius: RADII.control, cursor: 'pointer', fontFamily: FONT_SANS,
  fontSize: '13px', fontWeight: 600, color: on ? COLORS.accent : COLORS.ink,
  border: `1px solid ${on ? COLORS.accent : COLORS.borderStrong}`,
  background: on ? COLORS.accentSoft : COLORS.surface,
});
const track = (on) => ({
  position: 'relative', display: 'inline-block', width: '34px', height: '20px', flexShrink: 0,
  borderRadius: RADII.pill, boxSizing: 'border-box',
  border: `1px solid ${on ? COLORS.accent : COLORS.borderStrong}`,
  background: on ? COLORS.accent : COLORS.field,
});
const knob = (on) => ({
  position: 'absolute', top: '2px', left: on ? '16px' : '2px', width: '14px', height: '14px',
  borderRadius: RADII.pill, background: COLORS.surface, transition: 'left 150ms ease',
});
const BADGE = {
  padding: '2px 8px', borderRadius: RADII.pill, fontSize: '11px', fontWeight: 600,
  background: SEMANTIC.attenzione.bg, color: SEMANTIC.attenzione.fg,
};

export default function AdvancedToggle({ on, onChange, label, hiddenCount = 0, hiddenLabel }) {
  const showBadge = !on && hiddenCount > 0;
  return (
    <button type="button" role="switch" aria-checked={on} onClick={() => onChange(!on)} style={wrap(on)}>
      <span aria-hidden="true" style={track(on)}><span style={knob(on)} /></span>
      <span>{label}</span>
      {showBadge && <span style={BADGE}>{hiddenLabel}</span>}
    </button>
  );
}
